module.exports = __webpack_public_path__ + "img/background-study-assessor.8f320979.jpg";